import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import "./index.css";
import { Toaster } from "react-hot-toast";
import Home from "./pages/Home";
import About from "./pages/About";
import Talent from "./pages/Talent";
import Shows from "./pages/Shows";
import Crew from "./pages/Crew";
import Bookings from "./pages/Bookings";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import Upload from "./pages/Upload";
import Landing from "./pages/Landing";

function ScrollToTopOnRouteChange() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Use setTimeout to ensure DOM is ready before scrolling
    const timer = setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant"
      });
    }, 0);

    return () => clearTimeout(timer);
  }, [pathname]);

  return null;
}

const App = () => {
  const [hasEntered, setHasEntered] = useState(false);

  useEffect(() => {
    const handleContextMenu = (event) => {
      event.preventDefault();
    };

    document.addEventListener("contextmenu", handleContextMenu);
    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);

  // Check if user has already entered (stored in sessionStorage)
  useEffect(() => {
    const entered = sessionStorage.getItem('hasEnteredSite');
    if (entered === 'true') {
      setHasEntered(true);
    }
  }, []);

  const handleEnter = () => {
    setHasEntered(true);
    sessionStorage.setItem('hasEnteredSite', 'true');
  };

  // Show landing page if user hasn't entered yet
  if (!hasEntered) {
    return <Landing onEnter={handleEnter} />;
  }

  return (
    <div className="App">
      <Router>
        <ScrollToTopOnRouteChange />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/talent" element={<Talent />} />
          <Route path="/shows" element={<Shows />} />
          <Route path="/crew" element={<Crew />} />
          <Route path="/bookings" element={<Bookings />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/upload" element={<Upload />} />
        </Routes>
      </Router>
      <Toaster />
    </div>
  );
};

export default App;
